/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GridHeight = '100%';
export const GridWidth = "100%";

export const Width_100= 100;
export const Width_80 = 80;
export const Width_150 =150;
export const Width_180 =180;
export const Width_200=200;
export const Width_600=600;
export const Width_250=250;
export const Length_30=30;
export const Length_10=10;
export const Length_255=255;
export const BorderColor= '#D6D2D0';